// 사이드바 SDK 관리 - 각 SDK별 기능 목록 생성
import type { SDKType } from '../../../types/global.types';

import { getMenuById } from '../../../config/menu.config';
import i18n from '../../../i18n';

// SDK 카테고리 ID로 SDK 타입 매핑
export const getSDKTypeByCategory = (categoryId: SDKType): string | null => {
  return categoryId;
};

// 기능이 없는 SDK인지 확인 - 설정 기반
export const isEmptySDK = (categoryId: SDKType): boolean => {
  const menuConfig = getMenuById(categoryId);
  return menuConfig ? !menuConfig.hasFeatures : false;
};

// 가상 기능이 없는 SDK용 - UI 표시 목적 (설정 기반)
export const createVirtualFeature = (sdkType: SDKType) => {
  const menuConfig = getMenuById(sdkType);
  if (!menuConfig) {
    throw new Error(`Menu config not found for SDK type: ${sdkType}`);
  }

  return {
    id: menuConfig.id,
    title: i18n.t(`sidebar.categories.${sdkType}`),
    description: i18n.t(`common:${menuConfig.descriptionKey}`),
    category: sdkType,
    testData: {},
  };
};
